import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { IntercomService } from 'src/app/services/intercom.service';

@Component({
  selector: 'app-intercom-chat-nudge',
  templateUrl: './intercom-chat-nudge.component.html',
  styleUrls: ['./intercom-chat-nudge.component.css'],
})
export class IntercomChatNudgeComponent implements OnInit {
  constructor(
    private intercomService: IntercomService,
    private cdr: ChangeDetectorRef
  ) {}

  @Input() currentUser: any;

  public isEligibleForIntercomChat: boolean = false;
  public isOpenState: boolean = false;
  public intercomChatOpen: boolean = false;

  ngOnInit(): void {
    this.checkIfUserIsEligibleForIntercomChat();
  }

  private checkIfUserIsEligibleForIntercomChat(): void {
    if (!this.currentUser || !this.currentUser?.is_7_days_free_trial) {
      this.isEligibleForIntercomChat = false;
      return;
    }

    this.detectIntercomInitialState();
    this.setupIntercomListeners();

    this.isEligibleForIntercomChat = true;

    this.isOpenState = false;

    setTimeout(() => {
      this.isOpenState = true;
    }, 1000);
  }

  private detectIntercomInitialState(): void {
    const messengerFrame = document.querySelector(
      '[class*="intercom-with-namespace"]'
    ) as HTMLElement;
    if (messengerFrame) {
      this.intercomChatOpen = true;
    } else {
      this.intercomChatOpen = false;
    }
  }

  private setupIntercomListeners(): void {
    if (window.Intercom) {
      window.Intercom('onShow', () => {
        this.intercomChatOpen = true;
        this.cdr.detectChanges();
      });
    }
  }

  public openIntercomChat(): void {
    this.intercomService.openChat();
    this.intercomChatOpen = true;
    this.cdr.detectChanges();
  }
}
